// extracted by mini-css-extract-plugin
export default {"container":"Yaa-z","oos":"Zaa-z","oosUx":"_aa-z","selected":"aba-z","labelOos":"bba-z"};